import * as React from 'react';
import TableCell from '@material-ui/core/TableCell';

const CustomTableCell = (props) => {
    return <TableCell {...props} />;
};

export { CustomTableCell as TableCell };
